<script>
import { type } from '../utils/assist'
import mBase from './m-base'

// 插件-地理坐标转换
export default {
    name: 'AMapGeocoder',
    abstract: true, // 抽象组件
    mixins: [mBase],
    inject: {
        amap: { default: null },
    },
    data() {
        return {
            configExclude: ['address', 'location'],
            geocoder: null,
        }
    },
    props: {
        // 设置地址描述所在城市
        // 可选值：城市名（中文或中文全拼）、citycode、adcode
        city: {
            type: String,
            default: '全国',
        },
        // 逆地理编码时，以给定坐标为中心点，单位：米
        radius: {
            type: Number,
            default: 1000,
            validator(val) {
                return val >= 0 && val <= 3000
            },
        },
        // 设置语言类型
        lang: {
            type: String,
        },
        // 是否批量查询
        batch: {
            type: Boolean,
        },
        // 逆地理编码时，返回信息的详略
        extensions: {
            type: String,
            default: 'base',
            validator(val) {
                return ['all', 'base'].indexOf(val) >= 0
            },
        },
        // 地址
        address: {
            type: String,
            default: '',
        },
        // 地理定位
        location: {
            type: [Array, Object],
        },
    },
    methods: {
        initGeocoder() {
            if (AMap && AMap.Geocoder) {
                this.geocoder = new AMap.Geocoder(this.config)

                // 事件监听
                this._attachEvents(this.geocoder)

                return this.geocoder
            } else {
                return new Error('AMap.Geocoder插件未加载')
            }
        },
        getLocation(addr) {
            return new Promise((resolve, reject) => {
                this.geocoder.getLocation(addr, (status, result) => {
                    if (status === 'complete') {
                        return resolve(result.geocodes[0])
                    }

                    if (status === 'error') {
                        return reject(result)
                    }

                    // status == 'no_data'
                    resolve()
                })
            })
        },
        getAddress(loc) {
            return new Promise((resolve, reject) => {
                this.geocoder.getAddress(loc, (status, result) => {
                    if (status === 'complete') {
                        return resolve(result.regeocode)
                    }

                    if (status === 'error') {
                        return reject(result)
                    }

                    // status == 'no_data'
                    resolve()
                })
            })
        },
    },
    render(h) {},
    watch: {
        // 切换城市
        city(val) {
            if (this.geocoder) {
                this.geocoder.setCity(val)
            }
        },
        // 地址变换，查询经纬度
        address(val) {
            if (this.geocoder && val) {
                this.getLocation(val)
                    .then(geocode => {
                        this.$emit('geocode', geocode)
                    })
                    .catch(info => {
                        this.$emit('error', {
                            type: 'geocode',
                            info,
                        })
                    })
            }
        },
        // 经纬度变换，查询地址
        location(val) {
            if (this.geocoder && val) {
                this.getAddress(val)
                    .then(regeocode => {
                        this.$emit('regeocode', regeocode)
                    })
                    .catch(info => {
                        this.$emit('error', {
                            type: 'regeocode',
                            info,
                        })
                    })
            }
        },
    },
    created() {
        this.$watch(
            function() {
                return this.amap.loaded
            },
            function(load) {
                // map 创建完毕
                if (load) {
                    var geocoder = this.initGeocoder()

                    if (type(geocoder) == 'error') {
                        throw geocoder
                    }

                    this.amap.geocoders.push(geocoder)
                }
            },
            {
                immediate: true,
            }
        )
    },
    beforeDestroy() {
        if (this.geocoder) {
            // 从amap移除
            this.amap.geocoders.splice(
                this.amap.geocoders.indexOf(this.geocoder),
                1
            )
            // 事件解绑
            this._detachEvents(this.geocoder)
            //
            this.geocoder = null
        }
    },
}
</script>
